import { render, staticRenderFns } from "./LabelPrinter.vue?vue&type=template&id=5d0a88c0&scoped=true"
import script from "./LabelPrinter.vue?vue&type=script&lang=js"
export * from "./LabelPrinter.vue?vue&type=script&lang=js"
import style0 from "./LabelPrinter.vue?vue&type=style&index=0&id=5d0a88c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a88c0",
  null
  
)

export default component.exports